import AuthAxios from '@/lib/api/axios/AuthAxios'
import { ENDPOINT_BASE } from '@/config/endpoints'

const webPushBase = `${ENDPOINT_BASE}/users/web-push`

export interface VapidKeyResponse {
  vapidPublicKey: string | null
  isConfigured: boolean
}

export interface RegisterWebPushRequest {
  endpoint: string
  p256dh: string
  auth: string
  userAgent?: string | null
}

export interface RegisterWebPushResponse {
  subscriptionId: string
  isNew: boolean
}

export interface UnregisterWebPushRequest {
  endpoint: string
}

export interface UnregisterWebPushResponse {
  deleted: boolean
}

export const getVapidKey = async (): Promise<VapidKeyResponse> => {
  const response = await AuthAxios.get<VapidKeyResponse>(`${webPushBase}/vapid-key`)
  return response.data
}

export const registerWebPush = async (
  request: RegisterWebPushRequest,
): Promise<RegisterWebPushResponse> => {
  const response = await AuthAxios.post<RegisterWebPushResponse>(
    `${webPushBase}/register`,
    request,
  )
  return response.data
}

export const unregisterWebPush = async (
  request: UnregisterWebPushRequest,
): Promise<UnregisterWebPushResponse> => {
  const response = await AuthAxios.delete<UnregisterWebPushResponse>(
    `${webPushBase}/unregister`,
    { data: request },
  )
  return response.data
}
